function startProgressBarScript() {
  class ProgressBar extends HTMLElement {
    static get observedAttributes() {
      return ["value-now", "value-max"];
    }

    constructor() {
      super();
      this._onCartChangedListener = this._onCartChanged.bind(this);

      this.innerBar = this.querySelector(".bar-inner");
      if (!this.innerBar) {
        this.innerBar = document.createElement("div");
        this.innerBar.classList.add("bar-inner");
        this.appendChild(this.innerBar);
      }
    }

    connectedCallback() {
      this.valueNow = parseFloat(this.getAttribute("value-now")) || 0;
      this.valueMax =
        parseFloat(this.getAttribute("value-max")) ||
        parseFloat(this.getAttribute("aria-valuemax")) ||
        1000;

      document.addEventListener("cart:change", this._onCartChangedListener);
      this.updateProgress();
    }

    disconnectedCallback() {
      document.removeEventListener("cart:change", this._onCartChangedListener);
    }

    attributeChangedCallback() {
      this.valueNow = parseFloat(this.getAttribute("value-now")) || 0;
      this.valueMax =
        parseFloat(this.getAttribute("value-max")) ||
        parseFloat(this.getAttribute("aria-valuemax")) ||
        1000;

      this.updateProgress();
    }

    updateProgress() {
      let progress = 0;

      if (this.valueNow <= 499) {
        // Band 1 (0 – 499) → 0 – 33.3%
        progress = (this.valueNow / 499) * 33.3;

      } else if (this.valueNow <= 699) {
        // Band 2 (500 – 699) → 33.3 – 66.6%
        progress =
          33.3 +
          ((this.valueNow - 499) / (699 - 499)) * 33.3;

      } else if (this.valueNow <= 999) {
        // Band 3 (700 – 999) → 66.6 – 100%
        progress =
          66.6 +
          ((this.valueNow - 699) / (999 - 699)) * 33.4;

      } else {
        // Above 999 → cap at 100%
        progress = 100;
      }

      this.innerBar.style.width = `${progress}%`;
      this.setAttribute("aria-valuenow", this.valueNow.toFixed(2));
    }

    _onCartChanged(event) {
      const cart = event?.detail?.cart;
      if (!cart) return;

      const items = Array.isArray(cart.items) ? cart.items : [];
      const discounts = Array.isArray(cart.cart_level_discount_applications)
        ? cart.cart_level_discount_applications
        : [];

      const priceForItems = items
        .filter((item) => item && item.requires_shipping)
        .reduce((sum, item) => sum + (parseFloat(item.final_line_price) || 0), 0);

      const cartDiscount = discounts.reduce(
        (sum, discount) => sum + (parseFloat(discount.total_allocated_amount) || 0),
        0
      );

      this.valueNow = (priceForItems - cartDiscount) / 100;
      this.setAttribute("value-now", this.valueNow.toFixed(2));
      this.updateProgress();
    }
  }

  if (!window.customElements.get("progress-bar")) {
    window.customElements.define("progress-bar", ProgressBar);
  }

  function initializeProgressBar() {
    const progressBars = document.querySelectorAll("progress-bar");
    if (!progressBars.length) return;

    progressBars.forEach((progressBarElement) => {
      const initialPrice =
        parseFloat(progressBarElement.getAttribute("value-now")) ||
        parseFloat(progressBarElement.getAttribute("aria-valuenow")) ||
        0;

      const maxThreshold =
        parseFloat(progressBarElement.getAttribute("value-max")) ||
        parseFloat(progressBarElement.getAttribute("aria-valuemax")) ||
        1000;

      progressBarElement.setAttribute("value-now", initialPrice);
      progressBarElement.setAttribute("value-max", maxThreshold);

      if (typeof progressBarElement.updateProgress === "function") {
        progressBarElement.valueNow = initialPrice;
        progressBarElement.valueMax = maxThreshold;
        progressBarElement.updateProgress();
      }
    });
  }

  function reinitializeProgressBar() {
    [0, 120, 300, 700, 1200].forEach((delay) => {
      setTimeout(() => {
        initializeProgressBar();
      }, delay);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initializeProgressBar();
  });

  document.addEventListener("cart:change", (event) => {
    reinitializeProgressBar();

    const cart = event?.detail?.cart;
    if (!cart) return;

    [0, 120, 300, 700, 1200].forEach((delay) => {
      setTimeout(() => {
        document.querySelectorAll("progress-bar").forEach((bar) => {
          if (typeof bar._onCartChanged === "function") {
            bar._onCartChanged({ detail: { cart } });
          }
        });
      }, delay);
    });
  });

  document.addEventListener("cart:refresh", () => {
    reinitializeProgressBar();
  });
}

// Delay execution until lazy scripts are done
if ("requestIdleCallback" in window) {
  requestIdleCallback(startProgressBarScript);
} else {
  setTimeout(startProgressBarScript, 300);
}